import { createSelector } from 'reselect';
import _unescape from 'lodash/unescape';
import { getBusinessDetails } from '@/selectors/merchant';

export const getDefaultState = createSelector(
  getBusinessDetails,
  ({ storeId, storeName, email, website, goodsCategory }) => ({
    storeId,
    storeName: _unescape(storeName),
    website,
    email,
    goodsCategory,
  }),
);
